import { createEvent, sample } from 'effector'
import { CreateFileManagerFormItem, UpdateFileManagerFormItem } from './types'
import { fx } from '../../../../../../libs'
import { $params } from '../../../../../../features/router'

export const submitCreateSocialMediaFile =
  createEvent<CreateFileManagerFormItem>()

export const submitUpdateSocialMediaFile =
  createEvent<UpdateFileManagerFormItem>()

export const createFileManagerFile = fx<CreateFileManagerFormItem, void>({
  method: 'POST',
  url: '/partner/material/website_banner_file',
})

export const updateFileManagerFile = fx<UpdateFileManagerFormItem, void>({
  method: 'POST',
  url: '/partner/material/website_banner_file/${id}',
})

sample({
  clock: submitCreateSocialMediaFile,
  source: $params,
  fn: (params, websiteBannerFile) => {
    let id
    if (params) {
      id = params.websiteBannerID
    }

    return {
      url: `/partner/material/website_banner_file`,
      formData: { ...websiteBannerFile, websiteBannerId: Number(id) },
    }
  },
  target: createFileManagerFile,
})

sample({
  clock: submitUpdateSocialMediaFile,
  source: $params,
  fn: (params, websiteBannerFile) => {
    let id
    if (params) {
      id = params.websiteBannerID
    }

    return {
      url: `/partner/material/website_banner_file/${websiteBannerFile.id}`,
      formData: { ...websiteBannerFile, websiteBannerId: Number(id) },
    }
  },
  target: updateFileManagerFile,
})
